import React from 'react';
import styled, { useTheme } from 'styled-components';

interface ISvg {
	_fill?: string;
	children?: JSX.Element | JSX.Element[];
	_margin?: string;
	_onClick?: (() => void) | null;
	onMouseEnter?(): void;
	onMouseLeave?(): void;
	_size?: string;
}

const CoreSvg = ({
	_fill,
	children,
	_margin,
	_onClick,
	onMouseEnter,
	onMouseLeave,
	_size,
}: ISvg) => {
	const theme = useTheme();
	return (
		<SvgWrapper
			_fill={_fill ?? theme.colors.gray.gray80_text}
			_margin={_margin}
			onClick={() => _onClick && _onClick()}
			onMouseEnter={() => onMouseEnter && onMouseEnter()}
			onMouseLeave={() => onMouseLeave && onMouseLeave()}
			is_click={_onClick ? true : false}
			_size={_size}
		>
			{children}
		</SvgWrapper>
	);
};

const SvgWrapper = styled.span<{
	_fill?: string;
	_margin?: string;
	is_click: boolean;
	_size?: string;
}>`
	display: block;
	width: ${({ _size }) => _size ?? '24px'};
	height: ${({ _size }) => _size ?? '24px'};
	${({ theme }) => theme.common.flexCenter};
	${({ _margin }) => _margin && `margin: ${_margin}`};
	flex-shrink: 0;

	${({ is_click }) => is_click && 'cursor: pointer'};

	& > svg {
		fill: ${({ _fill }) => _fill ?? ''};
		width: 100%;
		height: 100%;
	}
`;

export default CoreSvg;

// svg파일 사용 시 컬러를 바꾸기 위한 용도로 사용되는 컴포넌트
//
// props
// -_fill: 바꾸고자 하는 컬러 값 (입력하지 않는 경우 검정색)
// -children: import한 svg를 담는다
